module.exports = __webpack_public_path__ + "assets/img/mecha-btn-226810e1.png";